<template>
    <el-dialog
        title="Driver Upload"
        :visible.sync="showForm"
        append-to-body
        :close-on-click-modal="false"
    >
        <span slot="footer" class="dialog-footer">
            <el-button @click="showForm = false">Close</el-button>
            <el-button type="primary" @click="save">Save</el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
      props: [
            'show'
        ],
        data() {
            return {
            };
        },
        computed: {
            showForm: {
                get() { return this.show; },
                set(val) { this.$emit('close'); }
            }
        },
        methods: {
            save() {
            },
            refresh() {
            }
        }
    }
</script>